<template lang="html">
  <section class="app-footer text-white d-flex justify-content-center">
    <p class="m-0 p-1 align-self-center">All rights reserved. &copy;ridiluamba.com</p>
  </section>
</template>

<script lang="js">
export default {
  name: 'Footer',
  props: [],
  mounted () {},
  data () {
    return {}
  },
  methods: {},
  computed: {}
}
</script>

<style scoped lang="scss">
  .app-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: var(--dark-color);
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue